import * as Sentry from '@sentry/browser'
import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Hangouts, ContentViewer } from 'views'
import { Layout } from 'components'
import Client from 'utils/client'
import { getToken } from 'utils/token'

import './App.module.scss'

class App extends Component {
  state = { user: undefined }
  async componentDidMount() {
    try {
      if (window.tracker) {
        window.tracker.pageView()
      }

      const user = await this.client.getProfile()

      if (!user) {
        return
      }

      this.setState({ user })

      Sentry.configureScope(scope => {
        scope.setUser({ email: user.email, id: user.id.toString(), username: user.name })
        scope.setExtras({ accessToken: getToken() })
      })
    } catch (e) {
      console.error(e) // eslint-disable-line no-console
    }
  }

  client = new Client({
    accessToken: getToken(),
  })

  render() {
    const { user } = this.state

    if (!user) {
      return null
    }

    return (
      <Layout>
        <Switch>
          <Route
            exact
            path='/hangouts/:id?'
            component={props => <Hangouts {...props} user={user} />}
          />
          <Route
            exact
            path='/aberto/:id'
            component={props => <ContentViewer {...props} repository='aberto' user={user} />}
          />
          <Route
            exact
            path='/e24h/:id'
            component={props => <ContentViewer {...props} repository='e24h' user={user} />}
          />
        </Switch>
      </Layout>
    )
  }
}

export default App
